import React from 'react';
import { useSocieta } from '../context/SocietaContext';
import { usePermesso } from '../context/PermessiContext';
import { useDirtyFormContext } from '../context/DirtyFormContext';
import ConfermaSocietaModal from './ConfermaSocietaModal';

/**
 * Componente "bridge" che collega SocietaContext, PermessiContext e
 * DirtyFormContext alle modali di conferma società. Va montato una sola volta
 * nel tree, tipicamente subito dopo il BrowserRouter dentro App.
 */
export default function SocietaModals() {
  const {
    societaAttiva,
    listaSocieta,
    showLoginConfirm,
    consumeLoginConfirm,
    pendingSocieta,
    pendingSocietaActive,
    confermaCambio,
    annullaCambio,
    setSocietaAttiva,
    bloccoContesto,
  } = useSocieta();
  const { utente } = usePermesso();
  const { dirtyLabels, resetAll } = useDirtyFormContext();

  const isSuperadmin = utente?.ruolo === 'SUPERADMIN';

  return (
    <>
      {showLoginConfirm && (
        <ConfermaSocietaModal
          variante="login"
          societaCorrente={societaAttiva}
          listaSocieta={listaSocieta}
          isSuperadmin={isSuperadmin}
          dirtyLabels={[]}
          onConferma={(scelta) => {
            // Se l'utente ha cambiato dalla combo della modale, applica il cambio
            if ((scelta?.id ?? null) !== (societaAttiva?.id ?? null)) {
              setSocietaAttiva(scelta);
            }
            consumeLoginConfirm();
          }}
        />
      )}

      {pendingSocietaActive && (
        <ConfermaSocietaModal
          variante="cambio"
          societaCorrente={societaAttiva}
          societaTarget={pendingSocieta}
          listaSocieta={listaSocieta}
          isSuperadmin={isSuperadmin}
          dirtyLabels={dirtyLabels}
          bloccoLabel={bloccoContesto?.label ?? null}
          onConferma={() => {
            confermaCambio();
            resetAll();
          }}
          onAnnulla={annullaCambio}
        />
      )}
    </>
  );
}
